// extracted by mini-css-extract-plugin
export default {"container":"NftHistoryModal_container__X+YIy","transactions":"NftHistoryModal_transactions__HkeMR"};